import gameIds from '../data/GameIds';

export const initialState = {
  config: [
    {
      blocks: {
        core: [
          {
            id: 'bd1',
            interactionId: 'intro',
            partId: 'episode01_part1',
            title: 'What is Setting?',
          },
          {
            id: 'bd2',
            interactionId: 'setting',
            partId: 'episode01_part1',
            title: 'Setting Application',
          },
          {
            id: 'bd3',
            interactionId: 'mood',
            partId: 'episode01_part1',
            title: 'What is Mood?',
          },
          {
            id: 'bd4',
            interactionId: 'building',
            partId: 'episode01_part1',
            title: 'Mood Application',
          },
          {
            id: 'bd5',
            interactionId: 'review',
            partId: 'episode01_part1',
            title: 'Review',
          },
          {
            id: 'bd6',
            interactionId: 'analyzeA',
            partId: 'episode01_part1',
            title: 'Close Reading Text 1',
          },
          {
            id: 'bd7',
            interactionId: 'analyzeB',
            partId: 'episode01_part1',
            title: 'Close Reading Text 2',
          },
          {
            id: 'bd8',
            interactionId: 'analyzeC',
            partId: 'episode01_part1',
            title: 'Close Reading Text 3',
          },
          {
            id: 'bd9',
            interactionId: 'phase3int',
            partId: 'episode01_part1',
            title: 'Phase 3: Complete the Motto',
          },
        ],
      },
      description: '',
      id: 'episode01',
      measurement: {},
      name: 'UNKNOWN',
      parts: [
        {
          id: 'episode01_part1',
          levels: [
            'rebel',
            'core',
          ],
          mode: 'tutor',
        },
      ],
      path: '/#/episode/tutor/episode01/core/episode01_part1/episode',
      rebelContent: false,
      teacherDesc: '',
      version: '0.1',
    },
    {
      description: '',
      id: 'episode02',
      measurement: {},
      name: 'UNKNOWN',
      parts: [
        {
          id: 'episode02',
          levels: [
            'rebel',
            'core',
          ],
          mode: 'tutor',
        },
      ],
      path: '/#/episode/tutor/episode02/core/episode02/episode',
      rebelContent: false,
      teacherDesc: '',
      version: '0.0',
    },
  ],
};

const tfeReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'FETCH_TFE_CONFIG_DATA_SUCCESS':
      return {
        config: [...action.payload.json],
      };
    default:
      return state;
  }
};

export default tfeReducer;
